<template>
  <div v-if="editData" style="display: table;">
    <div v-if="!isShowEdit">
      <table class="info-table">
        <tr>
          <td class="info-cell">
            <div class="cell-content">
              <div class="label">Room Prefer:</div>
              <div class="value" style="white-space: nowrap;" v-if="editData.roomPreferred">{{ editData.roomPreferred == '1' ? 'TWN' : 'DBL' }}</div>
            </div>
          </td>
          <td class="info-cell">
            <div class="cell-content">
              <div class="label">Meal Restriction:</div>
              <div class="value" :title="editData.mealsRequestName.map(formatName).join('; ')">{{ editData.mealsRequestName.map(formatName).join('; ') }}</div>
            </div>
          </td>
          <td class="info-cell">
            <div class="cell-content">
              <div class="label">Motion sickness:</div>
              <div class="value" :title="editData.specialRequestName.map(formatName).join('; ')">{{ editData.specialRequestName.map(formatName).join('; ') }}</div>
            </div>
          </td>
          <!-- <td class="info-cell">
            <div class="cell-content">
              <div class="label">Internal note:</div>
              <div class="value" :title="editData.specialNote">{{ editData.specialNote }}</div>
            </div>
          </td> -->
        </tr>
      </table>
    </div>
    <customer-airlines
      :ffpList="editData.ffpList"
      :airlineList="airlineList"
      :isEditTour="isEditTour"
      :globalCode="tourData.globalCode"
      :isShowEdit="isShowEdit"
      :isMainShow="isMainShow"
      ref="customerAirlines"
      @update="handleAirlinesUpdate"
    ></customer-airlines>
  </div>
</template>

<script>
// import CustomerApi from '@/api/api-cdb-custome-v2'
import CustomerAirlines from './CdbCustomerAirlinesFrequentFlyer'

export default {
  name: 'CdbCustomerTourList',
  components: {
    CustomerAirlines
  },
  props: {
    tourData: {
      type: Object,
      required: true
    },
    mealsList: {
      type: Array,
      default: () => []
    },
    specialList: {
      type: Array,
      default: () => []
    },
    airlineList: {
      type: Array,
      default: () => []
    },
    isEditTour: {
      type: Boolean,
      default: true
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      editData: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.editData = this.copyDataByJSON(this.tourData)
      
      // 餐食需求
      if (this.editData.mealsRequest?.trim()) {
        this.editData.mealsRequestName = this.editData.mealsRequest.split(',')
          .map(code => {
            const found = this.mealsList.find(item => item.code === code.trim())
            return found || { enName: code, twName: code }
          })
          .filter(item => item.enName && item.twName)
      } else {
        this.editData.mealsRequestName = []
      }

      // 特别需求 (同理)
      if (this.editData.specialRequest?.trim()) {
        this.editData.specialRequestName = this.editData.specialRequest.split(',')
          .map(code => {
            const found = this.specialList.find(item => item.code === code.trim())
            return found || { enName: code, twName: code }
          })
          .filter(item => item.enName && item.twName)
      } else {
        this.editData.specialRequestName = []
      }
    },
    formatName (item) {
      return item?.enName ? `${item.enName}/${item.twName}` : ''
    },
    handleAirlinesUpdate () {
      this.$emit('update')
    }
  },
  watch: {
    tourData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadData()
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.info-table {
  width: 100%;
  border-collapse: collapse;
  .info-cell {
    padding-right: 20px;
    vertical-align: top;
    .cell-content {
      display: flex;
      flex-direction: row; 
      gap: 8px;
      .label {
        font-weight: bold;
        color: #333;
        white-space: nowrap; 
      }
      .value {
        max-width: 200px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
    }
  }
}
</style>
